import React from 'react';
import { RepressIcon } from './styles';

const RepressedView = ({ onRepressClick }) => {
  return <RepressIcon onClick={onRepressClick} />;
};

export default RepressedView;
